import * as api from '../../api';

export const updateEmailActions = api.fetchActions('email', 'update-email');

export const actionTypes = {
  ...updateEmailActions.actionTypes,
};

export const updateEmail = (userId, currentPassword, newEmail) =>
  api.putThunk(`/participants/${userId}/email`, {currentPassword, newEmail }, updateEmailActions);



// WEBPACK FOOTER //
// src/acct/email/change-email.actions.js